import { esc, q } from '../../shared/dom';
import { t } from '../../shared/i18n';
import { ApiError } from '../../shared/api/http';
import { authApi } from './auth.api';
import { authRoutes } from './auth-routes';

/** Esqueci a senha: pede o e-mail e confirma o envio sem revelar se ele existe. */
export function renderForgotPasswordScreen(root: HTMLElement): void {
  root.innerHTML = `
    <h2 class="auth-title" data-i18n="auth.forgotTitle">${esc(t('auth.forgotTitle'))}</h2>
    <p class="auth-lead" data-i18n="auth.forgotLead">${esc(t('auth.forgotLead'))}</p>
    <form class="auth-form" id="forgot-form" novalidate>
      <div class="auth-field">
        <label for="forgot-email" data-i18n="auth.email">${esc(t('auth.email'))}</label>
        <input type="email" id="forgot-email" autocomplete="username" inputmode="email" placeholder="nombre@apuesterapido.com" required autofocus>
      </div>
      <div class="auth-error" id="forgot-error" role="alert"></div>
      <div class="auth-success" id="forgot-ok" role="status"></div>
      <button type="submit" class="btn btn-primary auth-submit" id="forgot-submit">${esc(t('auth.sendLink'))}</button>
      <div class="auth-links">
        <a class="auth-link" href="${authRoutes.login}" data-i18n="auth.backToLogin">${esc(t('auth.backToLogin'))}</a>
        <span></span>
      </div>
    </form>`;

  const form = q<HTMLFormElement>('#forgot-form', root);
  const email = q<HTMLInputElement>('#forgot-email', root);
  const error = q('#forgot-error', root);
  const ok = q('#forgot-ok', root);
  const submit = q<HTMLButtonElement>('#forgot-submit', root);

  form.addEventListener('submit', async e => {
    e.preventDefault();
    error.textContent = ''; ok.textContent = '';
    const mail = email.value.trim();
    if (!mail || !mail.includes('@')) { error.textContent = t('auth.errEmail'); email.focus(); return; }

    submit.disabled = true;
    try {
      await authApi.forgotPassword(mail);
      ok.textContent = t('auth.forgotSent');
      form.reset();
    } catch (err) {
      error.textContent = err instanceof ApiError && err.status === 429 ? t('auth.errTooMany') : t('auth.errGeneric');
    } finally {
      submit.disabled = false;
    }
  });
}
